<div class="dynamic-infomodal">
  @if (label) {
  <span class="dynamic-infomodal__label">{{ label }}</span>
  }
  <button
    type="button"
    class="dynamic-infomodal__trigger"
    (click)="open($event)"
    [attr.aria-label]="'Vis information: ' + modalTitle"
    title="Vis information"
  >
    <span class="dynamic-infomodal__icon" aria-hidden="true">i</span>
  </button>
</div>

@if (isOpen) {
<div
  #backdrop
  class="dynamic-infomodal-backdrop"
  (click)="onBackdropClick($event)"
  role="presentation"
>
  <div
    class="dynamic-infomodal-dialog"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="modalTitle"
    (click)="$event.stopPropagation()"
  >
    <div class="dynamic-infomodal-dialog__header">
      <h3 class="dynamic-infomodal-dialog__title">{{ modalTitle }}</h3>
      <button
        type="button"
        class="dynamic-infomodal-dialog__close"
        (click)="close($event)"
        aria-label="Luk"
      >
        ×
      </button>
    </div>
    <div class="dynamic-infomodal-dialog__body" [innerHTML]="cachedHtml"></div>
    <div class="dynamic-infomodal-dialog__footer">
      <button
        type="button"
        class="dynamic-infomodal-dialog__ok"
        (click)="close($event)"
      >
        Luk
      </button>
    </div>
  </div>
</div>
}
